import { Badge, Icon, IconNames } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { ampli } from 'lib-shared-tracking';
import { MouseEvent, MouseEventHandler } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import styles from './pageNavItem.module.scss';

type NavItemPropsT = {
  to: string;
  title: string;
  icon: IconNames;
  beta?: boolean;
  highlight?: boolean;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  notificationBadge?: boolean;
  onDismiss?: MouseEventHandler<HTMLElement>;
};
export const PageNavItem = ({
  to,
  title,
  icon,
  beta = false,
  highlight = false,
  notificationBadge = false,
  onDismiss,
  onClick,
}: NavItemPropsT): JSX.Element => {
  const location = useLocation();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    const isCtrlOrCmdPressed = event.metaKey || event.ctrlKey;
    const isSamePathname = to.split('?')[0] === location.pathname;

    // Prevent navigation if the user is already on the page. This ensures that any query parameters
    // such as filters are not lost if clicking the sidebar link while already on the page. Opening
    // the link in a new tab or window is still allowed by checking if the Ctrl/Cmd keys are pressed.
    if (isSamePathname && !isCtrlOrCmdPressed) {
      event.preventDefault();
      return;
    }

    ampli.sidebarNavClicked({ item: title });
    onClick?.(event);
  };

  return (
    <li className={styles.pageNavItem}>
      <NavLink
        className={({ isActive }) =>
          classnames(styles.pageNavBtn, {
            [styles.pageNavBtnActive]: isActive,
            [styles.pageNavBtnHighlight]: highlight,
          })
        }
        to={to}
        title={title}
        onClick={handleClick}
      >
        <Icon name={icon} size={20} className={styles.pageNavItemIcon} />
        <span className={styles.pageNavItemName}>{title}</span>

        {beta && (
          <Badge
            variant="primary"
            size="small"
            className={styles.pageNavItemBadge}
          >
            Beta
          </Badge>
        )}

        {notificationBadge && (
          <div className={styles.pageNavItemNotificationBadge} />
        )}

        {onDismiss && (
          <div className={styles.pageNavItemDismiss} onClick={onDismiss}>
            <Icon
              name="close"
              size={16}
              className={styles.pageNavItemDismissIcon}
            />
          </div>
        )}
      </NavLink>
    </li>
  );
};
